import { EquipmentCategory } from './equipmentCategory';

export class Equipment {

    constructor(_categoryId: number) {
        this.categoryId = _categoryId;
    }

    id: number;
    name: string;
    code: string;
    categoryId: number;
    category: EquipmentCategory;
    categoryName: string;
    displayOrder: number;
}